import {
  Code as CodeIcon,
  Smartphone as SmartphoneIcon,
  Codesandbox as CodeSandboxIcon,
  Grid as GridIcon,
  CheckCircle as ApprovalIcon,
  Star as StarIcon
} from 'react-feather';

const menuItems = [
  {
    title: 'HOME',
    hide_title: true,
    items: [
      {
        href: '/app/home',
        title: 'Back to Main Page',
        backward: true,
        className: 'nav-back-collections'
      }
    ]
  },
  {
    title: 'MY COLLECTIONS',
    items: [
      {
        href: '/app/manage/my-collections/templates',
        icon: GridIcon,
        title: 'My Templates',
        className: 'nav-collection-templates'
      },
      {
        href: '/app/manage/my-collections/apps',
        icon: CodeSandboxIcon,
        title: 'My Apps',
        className: 'nav-my-apps',
        isNew: false
      },
      {
        href: '/app/manage/my-collections/mobile-apps',
        icon: SmartphoneIcon,
        title: 'My Mobile Apps',
        className: 'nav-my-mobile-apps',
        isNew: false
      },
      {
        href: '/app/manage/my-collections/ps-assets',
        icon: StarIcon,
        title: 'My PS Assets',
        className: 'nav-my-ps-assets',
        isEAP: true,
        key: 'my-ps-assets',
        isNew: true
      },
      {
        href: '/app/manage/my-collections/snippets',
        icon: CodeIcon,
        title: 'My Snippets',
        className: 'nav-my-snippets',
        isNew: false
      },
      {
        href: '/app/manage/my-collections/approval-requests',
        icon: ApprovalIcon,
        title: 'My Approval Requests',
        className: 'nav-approvalrequests'
      }
    ]
  }
];

export default menuItems;
